/* Sections as panels. Sections that carry a tab name (data-rfhq-tab) form one panel each; the links to "#tab-<name>" (the three boxes on a home page, a bottom bar)
   choose which panel shows. The first shows at the start, or the one the address names. Without this script every panel shows, so nothing is ever hidden for good.
   No wording here: the names and the links come from the page. */
(function () {
	function init() {
		const sections = Array.from(document.querySelectorAll("[data-rfhq-tab]"));
		if (!sections.length) return;
		const names = Array.from(new Set(sections.map((s) => s.dataset.rfhqTab)));
		const links = () => Array.from(document.querySelectorAll('a[href^="#tab-"]'));

		let current = names[0];
		// The buttons are drawn after the page (a list from an app's endpoint): the chosen one is marked again when they arrive.
		function mark() {
			links().forEach((a) => {
				const on = a.getAttribute("href") === "#tab-" + current;
				a.setAttribute("aria-current", on ? "true" : "false");
				const box = a.closest(".rfhq-feature-card--box");
				if (box) box.classList.toggle("is-open", on);
			});
		}
		document.addEventListener("rfhq:records-drawn", mark);

		function open(name, remember) {
			if (!names.includes(name)) name = names[0];
			current = name;
			sections.forEach((s) => { s.hidden = s.dataset.rfhqTab !== name; });
			mark();
			if (remember) { try { window.history.replaceState(null, "", "#tab-" + name); } catch (e) { /* the address stays as it is */ } }
			// rows that were measured while hidden have no width: measure again now they show
			document.querySelectorAll("[data-rfhq-tab]:not([hidden]) .rfhq-swiper").forEach((el) => { if (el.swiper) el.swiper.update(); });
			window.dispatchEvent(new CustomEvent("rfhq:tab", { detail: { name } }));
		}

		document.addEventListener("click", (event) => {
			const a = event.target.closest('a[href^="#tab-"]');
			if (!a) return;
			event.preventDefault();
			open(a.getAttribute("href").slice(5), true);
		});
		window.addEventListener("hashchange", () => { if (/^#tab-/.test(window.location.hash)) open(window.location.hash.slice(5), false); });
		open(/^#tab-/.test(window.location.hash) ? window.location.hash.slice(5) : names[0], false);
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
